import * as _ from "lodash";
import { colorsConstants } from "../utils/constants/colors.constants";
import { Campaign } from "./campaign.model";

export class Division {
    public id: string | number | null = null;
    public name = "";
    public status = "Active";
    public lat: string | null = null;
    public long: string | null = null;
    public campaigns: Campaign[] = [];
    public color: string;

    public divisionid?: any;
    public restricted?: any;
    public expanded?: any;
    public stats?: any;
    public showCampaigns?: boolean;
    public type?: string;
    public campaignids?: any;
    public checked?: any;
    public tab?: any;

    constructor(data?: object) {
        this.color = this.randomColor();
        if (data) {
            this.setData(data);
        }
    }

    setData(data: any): void {
        if (data.divisionid) {
            data.id = data.divisionid;
        }
        _.merge(this, data);
    }

    randomColor(): string {
        const rand = Math.floor(
            Math.random() * colorsConstants.divisionColors.length
        );
        return colorsConstants.divisionColors[rand];
    }

    isValid(): boolean {
        return this.name ? this.name.trim() !== "" : false;
    }
}
